import { TopSpenderTable } from '../TopSpenderTable'
import { withTopMoneySpender } from './withTopMoneySpender'

const ConnectedTopMoneySpender = withTopMoneySpender(TopSpenderTable)

export { ConnectedTopMoneySpender as TopMoneySpender }
